import { IAPIResponseCustomerCare, ICustomerCare } from './customerCare.type';

export const customerCareSerializer = (
  apiCustomerCare: IAPIResponseCustomerCare
): ICustomerCare => apiCustomerCare.data.attributes;
